export default "__VITE_ASSET__bb612593__"